{{ 
  /* 
  A real world calendar example : https://vuetifyjscom-rbididdjsi.now.sh/en/components/calendars
  vuetify has a conflict version with current project, solved with this action: https://github.com/vuejs/vue-cli/issues/4513
  Calendars icons fails if this library is not installed: https://stackoverflow.com/questions/57053728/vuetify-icon-not-showing/57535771#57535771
   */ 
}}
<template>
  <v-layout fill-height class="mt-1">
    <v-flex>
      <v-sheet height="80vh">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="calendar_units"
          :event-color="getEventColor"
          :event-margin-bottom="3"
          :now="today"
          :type="type"
          :weekdays="weekdays"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
          event-name="titulo"
          event-text-color="black"
          :max-days="31"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <!-- <v-btn icon>
                <v-icon>edit</v-icon>
              </v-btn> -->
              <v-menu 
                open-on-hover 
                bottom 
                left 
                offset-x 
                content-class="qmkey-explorer-table-menu-contents"
              >
                <template v-slot:activator="{ on }">
                  <v-icon small class="mr-2" v-on="on">mdi-pencil</v-icon>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="transition in selectedEvent['transition_candidates']"
                    :key="transition.id"
                    @click.stop="performTransition(selectedEvent, transition)"
                  >
                    <v-list-item-title>{{ transition.label }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.details"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>      
    </v-flex>

    <!-- Modal dialog -->
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      @close-dialog="toggle_dialog"
      @submit="process_form"
    >
    </modal-dialog-form>
    <!--  /Modal dialog -->  
  </v-layout>
  
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import QUnit from '@/api/QUnit'
import DynamicForm from '@/components/DynamicForm'
import ModalDialogForm from './ModalDialog'


export default {
  name: 'ExplorerCalendar',
  components: {
    DynamicForm,
    ModalDialogForm
  },
  data: () => ({
    today: new Date().toISOString().split('T')[0],
    focus: new Date().toISOString().split('T')[0],
    type: 'month',
    weekdays: [1, 2, 3, 4, 5, 6, 0],
    start: null,
    end: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    addUnitBussinessProcess: '',
    addUnitParentProcess: '',
    business_process_name:'',
    disableAdddModalButtons: false,
    disableTransitionModalButtons: false,
    creation_fields_to_collect: [],
    creation_form_error_message: '',
    fields_to_collect: [],
    show_transitions: true,
    current_transition: {},
    alert: '',
    showModalDialog: false,
    valid: null,
    loading: false,
    showAddModalDialog: false,
    modal_title:'',
    submit_button_caption: '',
  }),
  computed: {
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC',
        month: 'long',
      })
    },
    ...mapState([
      'sitePath',
      'isLoading',
      'message',
      'sites',
      'transition_candidates',
      'current_business_process',
      'current_unit',
      'current_parent_process',
      'searchText',
      'filteredProcesses',
      'currentStandardID',
      'processID',
      'context_title',
      'calendar_units',
      'filterDates',
      'filterFormData'
  ]),
  },
  methods: {
    viewDay({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      return event.color
    },
    setToday() {
      this.focus = this.today
      this.updateProps();
    },
    prev() {
      this.$refs.calendar.prev()
      this.updateProps();
    },
    next() {
      this.$refs.calendar.next();
      this.updateProps();
    },
    setType(type) {
      this.type = type;
      this.updateProps();
    },
    setFocus(date){
      this.focus = date
      this.updateProps();
    },
    setDays(days){
      console.log('Calendar', days)
      this.weekdays = days
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => (this.selectedOpen = true), 10)
      }
      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    updateRange({start, end }) {
      // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
      this.start = start
      this.end = end
      this.updateProps();
      if (start && end) {
        this.updateCalendar()
      }
    },
    nth(d) {
      return d > 3 && d < 21
                        ? 'th'
                        : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    },
    getTitle() {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }

      const startMonth = this.monthFormatter(start)
      const startYear = start.year
      const startDay = start.day + this.nth(start.day)

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`
        case 'week':
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`
      }
    },
    updateProps() {
      this.$emit('update-calendar-props', {
        title: this.getTitle(),
        type: this.type,
        start: this.start,
        end: this.end
      });
    },
    updateCalendar() {
      // console.log('updateCalendar')
      if (this.$auth.isAuthenticated() && this.$session.exists('user')) {
        this.SET_BUSINESS_PROCESS(this.$route.query.business_process)
        // On reload get BP from querystring
        this.events = []
        let start = new Date(this.start.date)
        let end = new Date(this.end.date)
        // Ensure calendar dates range is valid for current filter_dates
        if (this.filterDates.length >0){
          let filter_start = new Date(this.filterDates[0])
          let filter_end = new Date(this.filterDates[1])
          if (start < filter_start && start.getMonth() == filter_start.getMonth()){
            start = filter_start
          }
          else if (start < filter_start || start > filter_end){
            start = null
          }
          if (end > filter_start && end > filter_end && end.getMonth() == filter_end.getMonth()){
            end = filter_end
          }
          else if (end > filter_start && end > filter_end){
            end = null
          }
        }
        if (start != null && end != null){
          this.EXPLORE_UNITS_CALENDAR({
            site: this.sitePath,
            bp_reference: this.current_business_process,
            process_id: this.processID,
            search_text: this.searchText,
            filters_form: this.filterFormData,
            start: start.toISOString().split('T')[0],
            end: end.toISOString().split('T')[0]
          })
        }
      }
    },
    ...mapActions(['GET_ALL_SITES', 'EXPLORE_UNITS_CALENDAR', 'OPEN_UNIT']),
    ...mapMutations([
      'SET_CURRENT_SITE',
      'SET_USER',
      'SET_MESSAGE',
      'SET_BUSINESS_PROCESS',
      'SET_CURRENT_UNIT',
    ]),
        // FORM
    addUnit(business_process, parent_qunit_id) {
      // Collect data to creation form
      this.creation_form_error_message = ''
      parent_qunit_id = parent_qunit_id || ''
      if (!business_process) {
        business_process = this.current_business_process
      }
      if (business_process) {
        QUnit.getFieldsToCollectDuringCreation(
          this.sitePath, business_process, parent_qunit_id)
          .then(data => {
            this.fields_to_collect = data['fields']
            // this.creation_fields_to_collect = data['fields']
            this.jsdata = data['js']
            this.addUnitBussinessProcess = business_process
            this.addUnitParentProcess = parent_qunit_id
            this.business_process_name = data['business_process_name']
            this.addModalDialog = true
            this.showModalDialog = true
            // TODO:Lang
            this.modal_title = 'Add new ' + this.business_process_name
            this.submit_button_caption = 'Add'
          })
          .catch(
            error =>
              (this.creation_form_error_message =
                error.body || error.response.data),
          )
      } else {
        this.creation_form_error_message = 'no business_process provided!'
        // this.showAddModalDialog = true
      } 
    },
    submitAddUnit(form_data) {
      // let current_item_uid = this.current_unit['uid']
      QUnit.createUnit(this.sitePath, form_data)
        .then(data => {
          this.selected = [data]
         this.showAddModalDialog = false
          this.selected = [data]          
          this.updateCalendar()
          this.toggle_dialog()
          

        })
        .catch(error =>{
            (this.creation_form_error_message =
              error.body || error);
            this.disableAdddModalButtons=false
        })
    }, 
    performTransition(unit, transition) {
      // this.SET_CURRENT_UNIT(unit)
      this.form_error_message = ''
      if (transition['related_business_process']) {
        this.addUnit(
          transition['related_business_process'],
          unit['uid'],
        )
      } else {
        QUnit.getFieldsToCollectDuringTransition(
          this.sitePath,
          unit['uid'],
          transition['id'],
        )
          .then(data => {
            this.creation_fields_to_collect = []
            this.fields_to_collect = data['fields']
            this.jsdata = data['js']
            this.current_transition = transition
            // this.$refs.transmodal.show()
            this.showModalDialog = true
            this.addModalDialog = false
            // TODO:Lang
            this.modal_title = this.current_transition.label
            this.submit_button_caption = 'Save'
          })
        .catch(
          error =>{
            (this.form_error_message = error.body || error.response.data);
        })
     }
    },
    submitTransition(form_data) {
      var new_items = []
      // form_data.append('transition_id', this.current_transition.id);
      this.$root.$loader.show('Sending...',{})  
      QUnit.executeTransition(
        this.sitePath,
        this.selectedEvent['uid'],
        form_data,
      )
        .then(data => {
          this.fields_to_collect = []
          this.form_error_message = ''
          // this.show_transitions = false
          // this.close()
          // this.show_transitions = true
          // this.disableTransitionModalButtons = false
          this.toggle_dialog()
          this.$root.$loader.hide()
          this.selectedOpen = false // close card
        })
        .catch(
          error =>{
            (this.form_error_message = error.body || error.response.data);
        })
    },
    toggle_dialog() {
      this.addUnitBussinessProcess = ''
      this.addUnitParentProcess = ''
      this.fields_to_collect = []
      this.creation_fields_to_collect = []
      this.showModalDialog = false
      this.addModalDialog = null
    },
    process_form: function (form_data) {
      console.log('ExplorerCalendar, form submit', form_data)
      form_data.append('business_process', this.addUnitBussinessProcess)
      form_data.append('parent_process', this.addUnitParentProcess)
      if (this.addModalDialog) {
        console.log('ExplorerCalendar Perform add QUnit')
        this.submitAddUnit(form_data)        
      }else{
        console.log('ExplorerCalendarPerform Transition')
        form_data.append('transition_id', this.current_transition.id)
        this.submitTransition(form_data)
      }

    },
  
  },
  mounted() {
    // this.updateCalendar()
    this.focus = this.filterDates[0] ? new Date(this.filterDates[0]).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]
    
    this.updateProps();
  },
  // Watch current route change to reload BP
  watch: {
    $route(to, _from) {
      this.EXPLORE_UNITS_CALENDAR({
        site: this.sitePath,
        bp_reference: this.current_business_process,
        process_id: this.processID,
        search_text: this.searchText,
        fiters_form: this.filterFormData,
        start: this.start.date,
        end: this.end.date
      })
    },
    
  },
}
</script>


<style lang="scss">
 @import "@/sass/explorer.scss";
</style>
